<template>
  <!-- 菜单box -->
  <div class="selection-sort">
    <div class="menu_box border_bottom_dashed"
         style="border-bottom:none;">
      <div class="flex borderBottomDashed paddingAll20 flex_jc_sb">
        <div class="title_category flex_jc_center">分类：</div>
        <div class="classified_content"
             :class="{'sort':showSort}"
             ref="sort">
          <span @click="reset('constructionList')"
                :class="{'pitch_on':constructionListAll}">全部</span>
          <span v-for="(item,index) in constructionList"
                :key="index"
                :class="{'pitch_on':item.show,'construction':item.show}"
                @click="change('constructionList',index,item)">
            {{item.name}}
          </span>
        </div>
      </div>
      <div class="unfold flex_ai_center"
           v-if="showSort&&isShowSort"
           @click="tructionClick(false,'sort')"
      >
        <!-- @click="showSort = false" -->
        <span>展开</span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="unfold unfold-red flex_ai_center"
           v-if="!showSort&&isShowSort"
           @click="tructionClick(true,'sort')">
        <span>收起</span>
        <i class="el-icon-arrow-up"></i>
      </div>
    </div>
    <div class="menu_box border_bottom_dashed"
         style="border-bottom:none;border-top:none;">
      <div class="flex borderBottomDashed paddingAll20 flex_jc_sb"
           v-show="constructionChildrenList.length>0">
        <div class="title_category flex_jc_center">类型：</div>
        <div class="classified_content"
             :class="{'sort':showChildren}"
             ref="childrenType">
          <span @click="reset('constructionChildrenList')"
                :class="{'pitch_on':constructionChildrenListAll}">全部</span>
          <span v-for="(item,index) in constructionChildrenList"
                :key="index"
                :class="{'pitch_on':item.show,'child':item.show}"
                @click="change('constructionChildrenList',index,item)">{{item.name}}</span>
        </div>
      </div>
      <div class="unfold flex_ai_center"
           v-if="showChildren&&isShowChildren"
           @click="tructionClick(false,'chid')">
        <span>展开</span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="unfold unfold-red flex_ai_center"
           v-if="!showChildren&&isShowChildren"
           @click="tructionClick(true,'chid')">
        <span>收起</span>
        <i class="el-icon-arrow-up"></i>
      </div>
    </div>
    <div class="menu_box border_bottom_dashed"
         style="border-top:none;">
      <div class="flex paddingAll20 flex_jc_sb">
        <div class="title_category flex_jc_center">所在城市：</div>
        <div class="classified_content"
             :class="{'province':showProvince}"
             ref="province">
          <span @click="reset('areaList')"
                :class="{'pitch_on':areaListAll}">全部</span>
          <span v-for="(item,index) in areaList"
                :key="index"
                :class="{'pitch_on':item.show}"
                @click="change('areaList',index,item)">{{item.simpleName}}</span>
        </div>
      </div>
      <div class="unfold flex_ai_center"
           v-if="showProvince&&isShowProvince"
           @click="showProvince = false">
        <span>展开</span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="unfold unfold-red flex_ai_center"
           v-if="!showProvince&&isShowProvince"
           @click="showProvince = true">
        <span>收起</span>
        <i class="el-icon-arrow-up"></i>
      </div>
    </div>
  </div>

</template>

<script>
import sessionStorage from '@/storage/sessionStorage'

export default {
  name: 'SelectionSort',
  components: { },
  data () {
    return {
      areaListAll: true,
      constructionListAll: true,
      constructionChildrenListAll: true,
      fromTypeAll: true,
      showProvince: false,
      showSort: false,
      showSortHtml: false,
      showChildrenHtml: false,
      showChildren: false,
      isShowProvince: false,
      isShowSort: false,
      isShowChildren: false
    }
  },
  computed: {},
  methods: {
    tructionClick (item, type) {
      if (type === 'sort') {
        this.showSort = item
        this.showSortHtml = !item
      } else {
        this.showChildren = item
        this.showChildrenHtml = !item
      }
    },
    reset (name, bol) {
      if (name !== 'all') {
        for (let i = 0; i < this[name].length; i++) {
          // this[name][i].show = false
          let arr = this[name][i]
          arr.show = false
          this[name].splice(i, arr)
        }
        this[name + 'All'] = true
        if (name === 'constructionList') {
          sessionStorage.clear('query')
        }
      } else {
        // for (let i = 0; i < this.constructionList.length; i++) {
        //   this.constructionList[i].show = false
        // }
        // this.constructionListAll = true
        // for (let i = 0; i < this.constructionChildrenList.length; i++) {
        //   this.constructionChildrenList[i].show = false
        // }
        // this.constructionChildrenListAll = true
        for (let i = 0; i < this.areaList.length; i++) {
          // this.areaList[i].show = false
          let arr = this.areaList[i]
          arr.show = false
          this.areaList.splice(i, arr)
        }
        this.areaListAll = true
        this.$emit('change', 'all', '', '')
        // this.resetConstructionChildrenCheck()
      }
      if (bol !== 1) {
        this.$emit('assignment', name)
      } else {
        this.$emit('assignment', name, 1)
      }
    },
    change (name, index, item) {
      if (name === 'constructionList' || name === 'constructionChildrenList') {
        this.resetConstructionChildrenCheck()
        if (name === 'constructionList') {
          this.showChildrenHtml = false
          this.showChildren = false
        }
      }
      this.reset(name, 1)
      this[name + 'All'] = false
      // this.$set(this[name][index], 'show', true)
      let arr = this[name][index]
      arr.show = true
      this[name].splice(index, arr)

      this.$emit('change', name, item, index)
    },
    resetConstructionChildrenCheck () {
      for (let i = 0; i < this.constructionChildrenList.length; i++) {
        this.$set(this['constructionChildrenList'][i], 'show', false)
        this.constructionChildrenListAll = true
      }
    }
  },
  props: {
    constructionList: {
      type: Array,
      required: true
    },
    areaList: {
      type: Array,
      required: true
    },
    constructionChildrenList: {
      type: Array,
      required: true
    }
  },
  watch: {
    areaList: {
      handler () {
        this.$nextTick(function () {
          let province = window.getComputedStyle(this.$refs.province).height
          let height = province.slice(0, -2)
          if (Number(height) > 50) {
            this.showProvince = true
            this.isShowProvince = true
          }
        })
      },
      deep: true
    },
    constructionList: {
      handler () {
        this.$nextTick(function () {
          let sort = window.getComputedStyle(this.$refs.sort).height
          let height = sort.slice(0, -2)

          if (Number(height) > 45 && !this.showSortHtml) {
            let construction = document.querySelector('.construction')
            if (construction !== null) {
              if (construction.offsetTop > 30) {
                this.showSort = false
              } else {
                this.showSort = true
              }
            } else {
              this.showSort = true
            }

            this.isShowSort = true
          }
        })
      },
      deep: true
    },
    constructionChildrenList: {
      handler () {
        //
        this.$nextTick(function () {
          let sort = window.getComputedStyle(this.$refs.childrenType).height

          let height = sort.slice(0, -2)
          if (Number(height) > 55 && !this.showChildrenHtml) {
            let child = document.querySelector('.child')
            //
            if (child !== null) {
              if (child.offsetTop > 30) {
                this.showChildren = false
              } else {
                this.showChildren = true
              }
            } else {
              this.showChildren = true
            }

            this.isShowChildren = true
          } else if (Number(height) < 55 && !this.showChildren) {
            this.showChildren = false

            this.isShowChildren = false
            this.showChildrenHtml = false
          }
        })
      },
      deep: true
    }
  },
  // async created () {
  //   this.new()
  //   await this.axios_infoAll()
  // },
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.bgff {
  color: #fff;
}

.selection-sort {
  width: 100%;
  margin-bottom: 10px;
  .menu_box {
    width: 1198px;
    margin: 0 auto;
    background: #ffffff;
    position: relative;
    border: 1px solid #e4e7ed;
    .nocheck {
      background: no-repeat url('../../../assets/screen/bg-nocheck.png') left
        top;
    }

    .check {
      background: no-repeat url('../../../assets/screen/bg-check.png') left top;
      z-index: 5;
    }

    .tag-inner {
      width: 155px;
      height: 50px;
      line-height: 50px;
      position: absolute;
      top: -52px;
      text-indent: 30px;
      cursor: pointer;
    }

    .talents {
      right: 260px;
      z-index: 3;
    }

    .construction-team {
      right: 130px;
      z-index: 2;
    }

    .company {
      right: 0;
      z-index: 1;
    }

    .title_category {
      width: 130px;
      text-align: center;
      /*height: 35px;*/
      color: #666666;
      font-weight: 400;
      font-size: 14px;
      /*padding-left: 16px;*/
      background-color: #f5f7fa;
    }

    .province {
      height: 40px;
      overflow: hidden;
    }

    .sort {
      height: 40px;
      overflow: hidden;
    }

    .classified_content {
      position: relative;
      flex: 1;
      margin-left: 15px;
      margin-right: 50px;
      //max-height: 50px;
      > span {
        margin-bottom: 5px;
        padding: 0 13px;
        height: 30px;
        font-size: 14px;
        color: #333;
        display: inline-block;
        line-height: 30px;
        text-align: center;
        cursor: pointer;
      }
    }

    .unfold {
      position: absolute;
      right: 0;
      top: 16px;
      width: 50px;
      font-size: 12px;
      color: #666;
      cursor: pointer;
      i {
        margin-left: 5px;
        transform: translateY(1px)
      }
    }
    .unfold-red {
      color: #ff6600;
    }
  }

  .borderBottomDashed {
    border-bottom: 1px dashed #e4e7ed;
  }

  .paddingAll20 {
    /*padding: 5px 20px 0;*/
    box-sizing: border-box;
    line-height: 46px;
  }

  .pitch_on {
    background: #0286df;
    color: #ffffff !important;
    border-radius: 4px;
  }
}
</style>
